import axios from "axios";
import { BASE_URL } from "./baseUrl";
import { getClientSource } from "./Functions";

/**
 * Loads an SOP document through the API (Bearer auth). Raw binary stream — not encrypted JSON.
 */
export async function fetchSopDocumentBlob(sopId) {
  const accessToken = localStorage.getItem("accessToken");
  const res = await axios.get(`${BASE_URL}/api/sops/${sopId}/view`, {
    responseType: "arraybuffer",
    headers: {
      ...(accessToken ? { Authorization: `Bearer ${accessToken}` } : {}),
      company_source: getClientSource(),
    },
    validateStatus: () => true,
  });

  if (res.status === 401) {
    window.location.href = "/login";
    throw new Error("Unauthorized");
  }

  if (res.status !== 200) {
    throw new Error("Could not load the SOP document.");
  }

  const contentType = res.headers["content-type"] || "application/octet-stream";
  return new Blob([res.data], { type: contentType });
}

export { isPdfMimeType, isImageMimeType } from "./financeDocumentFile";
